import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';

function ChemquoteExportModalFooter({ isFormAcceptable, isBusy, apply }) {
  return (
    <div className="exportModal__footer">
      <div className="exportModal__footer_buttons">
        <Button
          data-e2e="export-modal-apply"
          type="primary"
          size="small"
          onClick={apply}
          disabled={!isFormAcceptable || isBusy}
          className="e2e-modal-apply">
          Export
        </Button>
      </div>
    </div>
  );
}

ChemquoteExportModalFooter.propTypes = {
  isFormAcceptable: PropTypes.bool,
  isBusy: PropTypes.bool,
  apply: PropTypes.func.isRequired,
};

export default ChemquoteExportModalFooter;
